module.exports = __webpack_public_path__ + "img/source3_6.f8ab7ee8.png";